module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_truck":"No tachograph data available"},"de":{"no_truck":"Keine Tachografdaten verfügbar"},"fr":{"no_truck":"Aucune donnée de tachygraphe disponible"},"it":{"no_truck":"Nessun dato del tachigrafo disponibile"}}')
  delete Component.options._Ctor
}
